// Bravura Drive — Service Worker registration
// Only registers on driver routes; admin app remains uncached.
export function maybeRegisterDriverSW() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Skip in localhost dev (avoid stale cache during development)
  if (window.location.hostname === "localhost") return;

  const isDriverRoute = window.location.pathname.startsWith("/driver");
  if (!isDriverRoute) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => {
        // Non-fatal: app still works without SW
        // eslint-disable-next-line no-console
        console.warn("Bravura Drive SW registration failed", err);
      });
  });
}
